<template>
  <div>
    <h1>Generate secret.aes</h1>
    <input type="text" v-model="config" placeholder="AWS Constructor Config" />
    <input type="password" v-model="password" placeholder="Password" />
    <input type="password" v-model="confirm" placeholder="Confirm Password" />
    <input type="button" value="Encrypt" @click="encrypt()" />
    <div id="ciphertext">{{ cipher ? cipher : 'Cipher Text Will Go Here...' }}</div>
  </div>
</template>
<script>
  const sjcl = require('sjcl')

  export default {
    data: function () {
      return {
        config: '',
        password: '',
        confirm: '',
        cipher: ''
      }
    },
    methods: {
      encrypt: function () {
        if (!this.password) {
          alert('Password Required!')
          return
        }

        if (this.password !== this.confirm) {
          alert('Passwords do not match.')
          return
        }

        if (!this.config) {
          alert('Configuration string empty!')
          return
        }

        var encrypted = sjcl.encrypt(this.password, this.config)
        console.log(encrypted)
        this.cipher = encrypted
      }
    }
  }
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/GenSecret.vue